import { create } from 'zustand';

interface BodyOverlayValue {
  open: () => void;
  close: () => void;
  isOpen: boolean;
}

export const useBodyOverlay = create<BodyOverlayValue>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
